// The public domain that org subdomains live under. A tenant's storefront /
// preview URL is `{subdomain}${PUBLIC_DOMAIN_SUFFIX}` (e.g. `svt.xthory.com`).
// Single source of truth — the org-config form's subdomain suffix and the
// cms-public domain mapping both derive from this, so the brand domain is
// changed in one place.
export const PUBLIC_DOMAIN_SUFFIX = '.xthory.com';
